/**
 * Rebrand Theme Mapping
 *
 * This file maps semantic variable names to their new values for the rebrand.
 * The keys must match the CSS variable names defined in src/styles/semantic-theme.css.
 *
 * Values derived from Figma Design System.
 */
export const rebrandTheme = {
  // Colors: Brand
  '--primary-action-color': '#5b62e7', // Brand/Brand 500
  '--primary-action-hover': '#4c52c0', // Brand/Brand 600
  '--primary-action-active': '#3d419a', // Brand/Brand 700
  '--primary-action-soft': '#5b62e71a', // Alpha/Brand 10

  // Colors: Secondary/Accent
  // Using Brand 400/300 as secondary accents based on available palette
  '--secondary-color': '#7077ff', // Brand/Brand 400
  '--accent-color': '#9296ef', // Brand/Brand 300

  // Colors: Text
  '--text-primary': '#0c0c23', // Neutral/Black (Figma: Neutral/Black)
  '--text-secondary': '#5d5c6d', // Neutral/Neutral 600 / Text/Secondary
  '--text-link': '#5b62e7', // Brand/Brand 500
  '--text-disabled': '#9393a4', // Neutral/Neutral 400
  '--text-inverse': '#ffffff', // Neutral/White

  // Colors: Backgrounds
  '--bg-app': '#f4f4f5', // Neutral/Neutral 100
  '--bg-surface': '#ffffff', // Neutral/White / Surface/Base/Default
  '--bg-input': '#ffffff', // Surface/Base/Default
  '--bg-sidebar': '#080839', // Neutral/Navy (Surface/Inverse/Default)

  // Sidebar Layout
  '--sidebar-border-width': '0px', // No border in rebrand
  '--sidebar-border-radius': '10px', // Rounded corners
  '--sidebar-margin': '4px', // Margin to show background
  '--sidebar-padding': '4px', // Padding around sidebar

  // Sidebar Navigation
  '--nav-item-text': '#b5b7bb', // Icon/Tertiary
  '--nav-item-active-bg': '#7077ff', // Surface/Brand/Default-on-dark (Purple)
  '--nav-item-active-bg-focus': '#5b62e7', // Brand 500 — darker focus+selected shade
  '--nav-item-active-text': '#ffffff', // Text/On Color
  '--nav-item-hover-bg': '#b5b7bb33', // Surface/Base/Pressed (Alpha/Neutral 500 @ 20%)
  '--nav-item-hover-text': '#ffffff', // Text/On Color

  // Colors: Feedback
  '--color-error': '#f04a2d', // Red/Red 500
  '--bg-error': '#fff0eb', // Assuming light red background (not explicitly in vars, keeping legacy match or deriving)

  // Success - Not explicitly in variables provided, defaulting to Green
  // '--color-success': '#00D17A', // Keeping legacy
  // '--bg-success': '#E3FCEE', // Keeping legacy

  // Buttons
  '--btn-primary-bg': '#5b62e7', // Brand/Brand 500
  '--btn-primary-text': '#ffffff', // Neutral/White
  '--btn-secondary-bg': '#5b62e71a', // Button/Secondary/Default (Alpha/Brand 10)
  '--btn-secondary-bg-hover': '#5b62e733', // Button/Secondary/Hover (Alpha/Brand 20)
  '--btn-secondary-bg-active': '#5b62e74d', // Button/Secondary/Pressed (Alpha/Brand 30)
  '--btn-secondary-text': '#5b62e7', // Text/Brand (Brand/Brand 500)

  // Borders & Radii
  '--border-color': '#e1e1e5', // Border/Base (Neutral/Neutral 200)

  // Border Radii
  '--radius-sm': '8px', // rounded-8
  '--radius-md': '8px', // rounded-8
  '--radius-lg': '8px', // Extrapolated or maintain legacy if not found
  '--radius-round': '50%',
  '--radius-full': '9999px',

  // Typography
  '--font-family-primary': '"DM Sans", sans-serif',

  // Font Weights (DM Sans supports these)
  '--font-weight-light': '300',
  '--font-weight-regular': '400',
  '--font-weight-medium': '500',
  '--font-weight-bold': '700',
};
